import React from 'react';
import { Navigate } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import { LOCAL_STORAGE } from '../constants/constants';
import { hasAccessLevel, itAccessIds, userAccessIds } from '../constants/access-ids';

const ProtectedRoute = ({ children }) => {
    try {
        const accessToken = localStorage.getItem(LOCAL_STORAGE.JJ_INTERNAL);
        if (!accessToken) return <Navigate to="/portal" replace />;

        const userGroups = jwtDecode(accessToken).groups ?? [];
        const hasAccess = hasAccessLevel(userGroups, itAccessIds) ||
            hasAccessLevel(userGroups, userAccessIds);

        if (!hasAccess) return <Navigate to="/portal" replace />;
    } catch {
        return <Navigate to="/portal" replace />;
    }

    return children;
};

export default ProtectedRoute;